import React, { useEffect } from 'react';
import { useTenantBranding } from '@/hooks/useTenantBranding';
import type { LoadingStage } from '@/contexts/AuthContext';
import AuthShell from '@/features/auth/components/AuthShell';
import LoginForm from '@/features/auth/components/parts/LoginForm';
import LoadingProgress from '@/features/auth/components/parts/LoadingProgress';
import '@/features/auth/components/AuthGate.css';

interface AuthGateProps {
  /** When set, renders the post-login loading progress; otherwise the login form. */
  loadingStage?: Exclude<LoadingStage, null> | null;
}

export default function AuthGate({ loadingStage = null }: AuthGateProps) {
  const { branding, loading: brandingLoading } = useTenantBranding();

  const mode: 'login' | 'loading' = loadingStage ? 'loading' : 'login';

  useEffect(() => {
    if (branding) {
    }
  }, [branding]);

  return (
    <AuthShell>
      {(brandingLoading || !branding) && (
        <div className="auth-splash" role="status">
          Carregando...
        </div>
      )}

      {branding && !brandingLoading && (
        <div className="auth-content" data-mode={mode}>
          <div className="auth-card">
            <div className="auth-card-inner">
              {mode === 'login' ? (
                <LoginForm branding={branding} />
              ) : (
                <LoadingProgress stage={loadingStage!} branding={branding} />
              )}
            </div>
          </div>

          {mode === 'login' && (
            <div className="auth-tagline" aria-hidden="true">
              <h2 className="auth-tagline-heading">
                Experiência para o cliente,<br />
                <span className="auth-tagline-italic">tranquilidade para o integrador</span>
              </h2>
              <p className="auth-tagline-body">
                Da proposta à entrega — CRM, Projetos, Obras, Suprimentos e Financeiro integrados em um só lugar.
              </p>
            </div>
          )}
        </div>
      )}
    </AuthShell>
  );
}
